<div class="modal-header">
    <h4 class="modal-title fw-bold" id="importLotHeader" jhiTranslate="germplasm-coding.results.title">Coding Results</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="close()">
    </button>
</div>
<div class="modal-body">
    <div class="table-responsive" style="max-height: 600px; overflow: scroll;">
        <table class="table table-striped table-bordered table-curved table-fixed">
            <thead>
            <tr>
                <th scope="col" style="width: 20%" jhiTranslate="germplasm-coding.results.column.gid">GID</th>
                <th scope="col" style="width: 80%" jhiTranslate="germplasm-coding.results.column.result">Result</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let result of results">
                <td>{{result.gid}}</td>
                <td>
                    <ul>
                        <li *ngFor="let message of result.messages"> {{message}}</li>
                    </ul>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="close()"
        data-test="codingResultsConfirmButton">
        <span jhiTranslate="ok">OK</span>
    </button>
</div>
